module.exports = __webpack_public_path__ + "media/base/x-afedb5f6.svg";